<template>
  <section>
    <address-form
      ref="residentialComponent"
      v-bind:title="firstTitle"
      v-bind:parentAddress="residentialAddress"
      v-bind:states="geoLocation.states"
      v-bind:canada-states="geoLocation.canadaStates"
      v-bind:countries="geoLocation.countries"
      v-bind:key="1"
      v-bind:validate-washington="true"
      v-bind:is-admin="isAdmin"
      v-bind:selected-user-type="selectedUserType"
    />
   <fieldset v-if="showPOBoxInput" class="checkbox c-checkbox check-margin">
      <label>
        <input
        type="checkbox" value="" name="hasBeenAllowedPOBox"
          v-model="hasBeenAllowedPOBox" v-on:click="handleAllowPOBox">
        <span class="fa fa-check">
        </span>Allow PO Box
      </label>
    </fieldset>

    <fieldset class="checkbox c-checkbox check-margin mb-lg">
      <label>
        <input
        type="checkbox" value="" name="isMailingAddressDifferent"
          v-model="isMailingAddressDifferent" v-on:click="updateMailingAddress">
        <span class="fa fa-check">
        </span>Different mailing address
      </label>
    </fieldset>


    <address-form
      ref="mailingComponent"
      v-bind:title="secondTitle"
      v-bind:parentAddress="mailingAddress"
      v-bind:states="geoLocation.states"
      v-bind:canada-states="geoLocation.canadaStates"
      v-bind:countries="geoLocation.countries"
      v-bind:disabled="!isMailingAddressDifferent"
      v-bind:is-admin="isAdmin"
      v-bind:selected-user-type="selectedUserType"
      v-bind:isMailing="true"
    />
  </section>
</template>

<script>
  import {
    mapState,
  } from 'vuex';
  import address from '@/components/Address';

  export default {
    name: 'addresses',
    props: [
      'residentialAddress',
      'mailingAddress',
      'firstTitle',
      'secondTitle',
      'validateWashington',
      'isAdmin',
      'selectedUserType',
      'userHasBeenAllowedPOBox',
      'shouldShowAllowPOBoxInput',
    ],
    beforeMount() {
      this.loadState();
      this.hasBeenAllowedPOBox = this.userHasBeenAllowedPOBox;
      this.showPOBoxInput = this.shouldShowAllowPOBoxInput || false;
    },
    mounted() {
      this.$emit('validated', this.validate());
    },
    data() {
      return {
        isMailingAddressDifferent: false,
        hasBeenAllowedPOBox: false,
        showPOBoxInput: false,
      };
    },
    computed: {
      ...mapState('app', [
        'geoLocation',
      ]),
    },
    methods: {
      addressAreEqual(adr1, adr2) {
        return adr1.city === adr2.city &&
          adr1.state === adr2.state &&
          adr1.streetAddress1 === adr2.streetAddress1 &&
          adr1.streetAddress2 === adr2.streetAddress2 &&
          adr1.zipCode === adr2.zipCode;
      },

      loadState() {
        this.isMailingAddressDifferent = !this.addressAreEqual(this.residentialAddress,
        this.mailingAddress);
      },
      isResidentialAddressEmptyOrValid() {
        let isResidentialAddressValid = false;
        if (this.$refs.residentialComponent) {
          isResidentialAddressValid = this.$refs.residentialComponent.validate();
        }
        return this.$refs.residentialComponent.isEmpty() || isResidentialAddressValid;
      },
      isMailingAddressEmptyOrValid() {
        let isMailingAddressValid = false;
        if (this.$refs.mailingComponent) {
          isMailingAddressValid = this.$refs.mailingComponent.validate();
        }
        return this.$refs.mailingComponent.isEmpty() || isMailingAddressValid;
      },
      areEmpty() {
        return this.$refs.residentialComponent.isEmpty() &&
          this.$refs.mailingComponent.isEmpty();
      },
      validate() {
        let isResidentialAddressValid = false;
        let isMailingAddressValid = false;
        if (this.$refs.residentialComponent) {
          isResidentialAddressValid = this.$refs.residentialComponent.validate();
        }
        if (this.$refs.mailingComponent) {
          isMailingAddressValid = this.$refs.mailingComponent.validate();
        }
        return isResidentialAddressValid && isMailingAddressValid;
      },
      getData() {
        const residentialAddress = this.$refs.residentialComponent.getData();
        let mailingAddress = Object.assign({}, residentialAddress);
        if (this.isMailingAddressDifferent) {
          mailingAddress = this.$refs.mailingComponent.getData();
        }
        return { residentialAddress, mailingAddress };
      },
      handleAllowPOBox(event) {
        const { checked } = event.target;
        this.hasBeenAllowedPOBox = checked;
      },
      updateMailingAddress(event) {
        const { checked } = event.target;
        this.isMailingAddressDifferent = checked;
        if (!checked) {
          this.mailingAddress.streetAddress1 = this.residentialAddress.streetAddress1 || '';
          this.mailingAddress.streetAddress2 = this.residentialAddress.streetAddress2 || '';
          this.mailingAddress.zipCode = this.residentialAddress.zipCode || '';
          this.mailingAddress.city = this.residentialAddress.city || '';
          this.mailingAddress.state = this.residentialAddress.state || '';
          return;
        }
        this.mailingAddress.streetAddress1 = '';
        this.mailingAddress.streetAddress2 = '';
        this.mailingAddress.zipCode = '';
        this.mailingAddress.city = '';
        this.mailingAddress.state = '';
      },
      setResidencialAddress(newAddress) {
        if (this.$refs.residentialComponent) {
          this.$refs.residentialComponent.setAddress(newAddress);
        }
      },
      setMailingAddress(newAddress) {
        if (this.$refs.residentialComponent) {
          this.$refs.mailingComponent.setAddress(newAddress);
        }
      },
    },
    components: {
      'address-form': address,
    },
  };
</script>

<style scoped>
  .main-container {
    padding-top: 5;
  }

  .notes-list-title {
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .content-heading {
    font-weight: normal;
  }

  .top-margin {
    margin-top: 2%;
  }

  .line-separator {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }

  .panel-default {
    padding: 20px 30px;
  }

  .panel-heading {
    color: #444;
    background-color: #ffffff;
    border-color: #cfdbe2;
    border-bottom: 0;
    font-size: 14px;
    padding: 0px 5px;
  }

  table {
    border-collapse: collapse;
  }

  th {
    padding: 14px 8px;
    color: #888;
    border-bottom-width: 1px;
    vertical-align: bottom;
    border-bottom: 1px solid #eee;
    border-top: 0;
    line-height: 1.52857143;
    font-weight: normal;
  }

  td {
    padding: 8px;
    line-height: 1.52857143;
    vertical-align: top;
    border-top: 1px solid #eee;
  }

  .table-striped>tbody>tr:nth-of-type(odd) {
    background-color: #fafbfc;
  }

  .panel-title {
    font-size: 20px;
  }
  fieldset {
    border-color: transparent;
  }
</style>



// WEBPACK FOOTER //
// Addresses.vue?d53ceb32